import React , {useEffect, useState} from "react";
// react component plugin for creating a beautiful datetime dropdown picker
import Datetime from "react-datetime";
// react component plugin for creating beatiful tags on an input
import TagsInput from "react-tagsinput";
// plugin that creates slider
import Slider from "nouislider";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from "@material-ui/core/Switch";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// @material-ui/icons
import Today from "@material-ui/icons/Today";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import AvTimer from "@material-ui/icons/AvTimer";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import FormLabel from "@material-ui/core/FormLabel";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";

import { Link, Redirect, useParams } from "react-router-dom";

import axios from 'axios'

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { PUBLIC_IMAGE } from "../../constants";

const useStyles = makeStyles(styles);

//const image_url = "http://localhost:5000/public/";
const image_url = `${PUBLIC_IMAGE}/`

export default function EditUser() {

    

    const {id} = useParams();


    const [name, setregistername] = React.useState("");
    const [registernameState, setregisternameState] = React.useState("");

    const [username, setregisterusername] = React.useState("");
    const [registerusernameState, setregisterusernameState] = React.useState("");

    const [email, setregisteremail] = React.useState("");
    const [registeremailState, setregisteremailState] = React.useState("");

    const [registerPassword, setregisterPassword] = React.useState("");
    const [registerPasswordState, setregisterPasswordState] = React.useState("");
    const [password, setregisterConfirmPassword] = React.useState(
        ""
    );
    const [
        registerConfirmPasswordState,
        setregisterConfirmPasswordState
    ] = React.useState("");

    const [role, setSelectedRole] = React.useState("1");

    const [user_info, setuserinfo] = useState("");

    const [redirctTo, setRedirctTo] = useState(false);

    const [redirctTo_new_user, setRedirctTo_new_user] = useState(false);

    const [user_id_update, setuser_id_update] = React.useState("");

    const [token_logged, settoken_logged] = React.useState("");

    const [url, setavatar_url] = React.useState(false);

    const [tc, setTC] = React.useState(false);
    const [Errmessage, setErrmessage] = React.useState("");

    


    const handleChangeRole = event => {
      setSelectedRole(event.target.value);
    };

    const verifyLength = (value, length) => {
        if (value.length >= length) {
            return true;
        }
        return false;
    };

    const verifyEmail = value => {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    };

  
  React.useEffect(() => {
      document.getElementById("test_id").innerHTML = "Edit User";
      const local_login = localStorage.getItem('local_login')
      let token = "";
      if(local_login){
        try {
        const getToken = async () => {
          const res = await axios.post('/user/refresh_token', null)
          
          token = res.data.access_token;

          settoken_logged(token);

          const res2 = await axios.get('/user/infor', {
            headers: {Authorization: token}
          })     
          

          
          const res3 = await axios.post('/user/infor_edit', {id},{
                headers: {Authorization: token}
            })
            setavatar_url(res3.data.avatar);
            setregistername(res3.data.name);
            setSelectedRole( res3.data.role.toString() );
            setregisterusername(res3.data.username);
            setregisteremail(res3.data.email)
            setuser_id_update(id);
          
          
        }
        getToken()
          } catch (err) {
            setRedirctTo(true);
        }
      }else{
        setRedirctTo(true)
      }
    
  }, [  ]);
  

  const registerClick = async e => {
    
    e.preventDefault();
    let valid = 1;
    let avatar_url = "";
    if (name === "") {
       setregisternameState("error");
       valid = 0;
    }
    
    if (registerPassword != "") {
       
        //valid = 0;
        if(registerPassword.length < 6){
          setregisterPasswordState("error");
          setregisterConfirmPasswordState("error");
          valid = 0;
          setErrmessage("Password Minimum 6 Characters Required");
          showNotification(true);
        }

        if (registerPassword != password) {
          setregisterPasswordState("error");
          setregisterConfirmPasswordState("error");
          valid = 0;
        }
    }
    
    console.log(valid);
    if(valid === 1){

      try {
        const files = document.getElementById('file1');        
        const file = files.files[0]
        if(file.size > 1024 * 1024){

        }
        if(file.type !== 'image/jpeg' && file.type !== 'image/png'){

        }
        let formData =  new FormData()
        formData.append('file', file)

        const res = await axios.post('/api/upload_avatar', formData, {
            headers: {'content-type': 'multipart/form-data', Authorization: token_logged}
        })
        
        avatar_url = res.data;

      } catch (err) {
        //err.response.data.msg && 
        //setUser({...user, err: err.response.data.msg, success: ''})
      }  
      
      try {

        const res = await axios.patch('/user/update', {
          user_id_update, name, password, role, avatar_url
        },{
            headers: {Authorization: token_logged}
        })
        
        console.log(res.data.msg);

        setRedirctTo_new_user(true);

      } catch (err) {
          //err.response.data.msg && 
          //setUser({...user, err: err.response.data.msg, success: ''})
      }  
    }
    


  };

 

  const classes = useStyles();

  if (redirctTo){
    return <Redirect to='/auth/login-page'  />
  }

  if (redirctTo_new_user){
    return <Redirect to='/admin/users'  />
  }

  const showNotification = place => {
    setTC(true);
    setTimeout(function() {
      setTC(false);
    }, 3000);
  };
  
  
  return (
    <div>

      <Snackbar
        place="tc"
        color="rose"
        icon={AddAlert}
        message={Errmessage}
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
      
      
      <GridContainer>
              
        <GridItem xs={12} sm={12} md={12}>
            <div className={classes.right}>
                <Link to="/admin/users">
                  <Button color="rose" className={classes.right}>
                      Back to All Users
                  </Button>
                </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save User
                </Button>
            </div>
          <Card>
            <CardBody>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={registernameState === "success"}
                            error={registernameState === "error"}
                            labelText="Full Name"
                            id="name"
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    if (verifyLength(event.target.value, 1)) {
                                        setregisternameState("success");
                                    } else {
                                        setregisternameState("error");
                                    }
                                    setregistername(event.target.value);
                                },
                                
                            type: "text",
                            autoComplete: "off",
                            value: name
                            }}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={4} md={4}>
                    <legend>Image  (.PNG Recommended)</legend>
                    <span>Current:</span>
                    <br />
                    <div className="fileinput text-center">
                      <div className=" thumbnail" >
                        <img src={ image_url + url}></img>
                      </div>
                    </div>
                    <br />
                    <ImageUpload
                        url={url}
                        addButtonProps={{
                        color: "rose",
                        round: true
                        }}
                        changeButtonProps={{
                        color: "rose",
                        round: true
                        }}
                        removeButtonProps={{
                        color: "danger",
                        round: true
                        }}
                    />
                    </GridItem>
                </GridContainer>
              <br />
              <br />
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                
                  <div
                    className={
                      classes.checkboxAndRadio +
                      " " +
                      classes.checkboxAndRadioHorizontal
                    }
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          checked={role === "1"}
                          onChange={handleChangeRole}
                          value="1"
                          name="radio[]"
                          aria-label="A"
                          icon={
                            <FiberManualRecord
                              className={classes.radioUnchecked}
                            />
                          }
                          checkedIcon={
                            <FiberManualRecord
                              className={classes.radioChecked}
                            />
                          }
                          classes={{
                            checked: classes.radio,
                            root: classes.radioRoot
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot
                      }}
                      label="All"
                    />
                  </div>

                  <div
                    className={
                      classes.checkboxAndRadio +
                      " " +
                      classes.checkboxAndRadioHorizontal
                    }
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          checked={role === "2"}
                          onChange={handleChangeRole}
                          value="2"
                          name="radio[]"
                          aria-label="A"
                          icon={
                            <FiberManualRecord
                              className={classes.radioUnchecked}
                            />
                          }
                          checkedIcon={
                            <FiberManualRecord
                              className={classes.radioChecked}
                            />
                          }
                          classes={{
                            checked: classes.radio,
                            root: classes.radioRoot
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot
                      }}
                      label="Administrator"
                    />
                  </div>

                  <div
                    className={
                      classes.checkboxAndRadio +
                      " " +
                      classes.checkboxAndRadioHorizontal
                    }
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          checked={role === "3"}
                          onChange={handleChangeRole}
                          value="3"
                          name="radio[]"
                          aria-label="A"
                          icon={
                            <FiberManualRecord
                              className={classes.radioUnchecked}
                            />
                          }
                          checkedIcon={
                            <FiberManualRecord
                              className={classes.radioChecked}
                            />
                          }
                          classes={{
                            checked: classes.radio,
                            root: classes.radioRoot
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot
                      }}
                      label="Technician App"
                    />
                  </div>
                  
                </GridItem>
                
              </GridContainer>
              <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={registerusernameState === "success"}
                            error={registerusernameState === "error"}
                            labelText="User Name"
                            id="username"
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    if (verifyLength(event.target.value, 1)) {
                                        setregisterusernameState("success");
                                    } else {
                                        setregisterusernameState("error");
                                    }
                                    setregisterusername(event.target.value);
                                },
                                type: "text",
                                autoComplete: "off",
                                value: username,
                                disabled: true
                            }}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={registeremailState === "success"}
                            error={registeremailState === "error"}
                            labelText="Email"
                            id="name"
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    if (verifyEmail(event.target.value, 1)) {
                                        setregisteremailState("success");
                                    } else {
                                        setregisteremailState("error");
                                    }
                                    setregisteremail(event.target.value);
                                },
                                type: "text",
                                autoComplete: "off",
                                value: email,
                                disabled: true
                            }}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={registerPasswordState === "success"}
                            error={registerPasswordState === "error"}
                            labelText="Reset Password"
                            id="name"
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                            onChange: event => {
                                if (verifyLength(event.target.value, 1)) {
                                setregisterPasswordState("success");
                                } else {
                                //setregisterPasswordState("error");
                                }
                                setregisterPassword(event.target.value);
                            },
                            type: "password",
                            autoComplete: "off"
                            }}
                        />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <CustomInput
                            success={registerConfirmPasswordState === "success"}
                            error={registerConfirmPasswordState === "error"}
                            labelText="Re Enter New Password"
                            id="name"
                            formControlProps={{
                            fullWidth: true
                            }}
                            inputProps={{
                            onChange: event => {
                                if (registerPassword === event.target.value) {
                                setregisterConfirmPasswordState("success");
                                } else {
                                setregisterConfirmPasswordState("error");
                                }
                                setregisterConfirmPassword(event.target.value);
                            },
                            type: "password",
                            autoComplete: "off"
                            }}
                        />
                    </GridItem>
                </GridContainer>
              

            </CardBody>
          </Card>
          <div className={classes.right}>
              <Link to="/admin/users">
                <Button color="rose" className={classes.right}>
                    Back to All Users
                </Button>
              </Link>
                <Button onClick={registerClick} color="rose" className={classes.right}>
                    Save User
                </Button>
            </div>
        </GridItem>
      </GridContainer>
    </div>
  );
}
